/**
 * 색상 컨벤션 (NOTE)
 * - 기본 액센트(버튼 등): color="primary"  (= #7c4dff)
 * - v-tabs 활성색: 기본 color="primary lighten-1" 로 통일 (별도 토큰 없이 primary 종속)
 *   → primary만 바꾸면 탭색도 함께 따라감.
 *   예외) 섹션 아이덴티티 탭은 고유색 유지: 펫스토어 #8e6fd6 · 병원 #4a9e8f · 당근채집 #c98a2e
 */
import Vue from "vue";
import Vuetify from "vuetify/lib";
import ko from "vuetify/lib/locale/ko";
import en from "vuetify/lib/locale/en";
import ja from "vuetify/lib/locale/ja";

Vue.use(Vuetify);

export default new Vuetify({
  // Vuetify 내장 컴포넌트(데이트피커/페이지네이션 등) 메시지 로케일. current는 App.vue에서 i18n과 동기화.
  lang: {
    locales: { ko, en, ja },
    current: "ko",
  },
  theme: {
    // disable: true,
    // dark: true,
    // 테마 색을 CSS 변수(var(--v-<name>-base))로 노출 → scoped CSS에서 토큰 사용 가능
    options: { customProperties: true },
    themes: {
      light: {
        // 앱 기본 액센트 = 가장 많이 쓰는 버튼색(color="primary"). 미선언 컴포넌트도 이 값 사용.
        primary: "#7c4dff",
        secondary: "#b0bec5",
        accent: "#3f51b5",
        error: "#FF1744",
        // 사이드 메뉴 — 테마-가변: 배경 / 비활성 텍스트 / 활성 액센트
        sidebarBg: "#f4f5fa",
        sidebarText: "#322e45",
        sidebarAccent: "#6a2cd6",
        // 콘텐츠 패널/카드 배경 — 테마-가변(라이트=흰색 / 다크=어두운 카드). 기존 하드코딩 white 대체용.
        surface: "#ffffff",
        // 다크 서피스 토큰 (구독/구매 등 다크 비주얼 페이지용, 테마 무관 고정)
        surfaceDark: "#1a1a1a",
        surfaceCard: "#252525",
        accentViolet: "#7c4dff",
        textMuted: "#9ca3af",
        textSoft: "#d1d5db",
      },
      dark: {
        primary: "#7c4dff",
        secondary: "#b0bec5",
        accent: "#8c9eff",
        error: "#b71c1c",
        sidebarBg: "#15131c",
        sidebarText: "#dedbe9",
        sidebarAccent: "#c096ff",
        surface: "#1e1e1e",
        surfaceDark: "#1a1a1a",
        surfaceCard: "#252525",
        accentViolet: "#7c4dff",
        textMuted: "#9ca3af",
        textSoft: "#d1d5db",
      },
    },
  },
});
